import { AIError } from './types';

export interface SongResearch {
  story: string;
  elements: string;
}

export const buildSongResearchPrompt = (query: string): string =>
  `Use web search to find the Hebrew song "${query}" and read its lyrics.

Then output exactly this format and nothing else:
STORY: <2-3 sentences in Hebrew describing the song's central storyline and mood, in your own words. Do not quote the lyrics.>
ELEMENTS:
<8 to 12 lines, one per line: the most prominent visual elements, characters, objects and actions in the song, as short simplified Hebrew phrases (for example "שותה תה" or "שיער ארוך"). Do not copy full lines from the song.>

Your answer will be used to draw a picture that hints at the song without giving it away, so:
- Never write the song's title or the name of any performer anywhere in your answer.
- Describe what the song is about, not who sings it: do not list a singer, a band, a stage, a microphone or a concert among the elements.

If you cannot find this song or its lyrics, output exactly: NOT_FOUND`;

const notFound = () =>
  new AIError('claude', 'Claude could not find this song. Check the song and artist names.');

export const parseSongResearch = (text: string): SongResearch => {
  const storyAt = text.lastIndexOf('STORY:');
  const elementsAt = text.lastIndexOf('ELEMENTS:');
  if (storyAt < 0 || elementsAt < storyAt) throw notFound();

  const story = text.slice(storyAt + 'STORY:'.length, elementsAt).trim();
  const elements = text
    .slice(elementsAt + 'ELEMENTS:'.length)
    .split('\n')
    .map(line => line.replace(/\*\*/g, '').replace(/^\s*(?:[-*•]|\d+[.)])\s*/, '').trim())
    .filter(line => line.length > 0)
    .join('\n');

  if (!story || !elements) throw notFound();
  return { story, elements };
};
